import { render, staticRenderFns } from "./AppDetailsTab.vue?vue&type=template&id=660767cf&scoped=true"
import script from "./AppDetailsTab.vue?vue&type=script&lang=js"
export * from "./AppDetailsTab.vue?vue&type=script&lang=js"
import style0 from "./AppDetailsTab.vue?vue&type=style&index=0&id=660767cf&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "660767cf",
  null
  
)

export default component.exports